import styled, { css } from 'styled-components/macro';

export const CardContainer = styled.div<{ margin?: string }>`
  margin: ${({ theme, margin }) => (margin ? margin : `${theme.spacing.one} 0`)};
  padding: ${({ theme }) => theme.spacing.one_2};
  border: 1px solid ${({ theme }) => theme.colors.black_20};
  border-radius: ${({ theme }) => theme.spacing.zero_2};
  background-color: ${({ theme }) => theme.colors.white};

  ${({ onClick }) =>
    !!onClick &&
    css`
      :hover {
        cursor: pointer;
      }
    `}
`;

export const CardHeader = styled.div<{ gap?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.zero_2};

  ${({ gap }) => gap && ` gap: ${gap};`}
`;

export const CardTitle = styled.h5`
  flex: 1 0 auto;
  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
`;

export const CardActions = styled.div<{ cardActionsIconColor?: string }>`
  flex: 0 0 auto;
  align-items: center;
  display: flex;
  align-self: flex-end;
  flex-wrap: nowrap;
  gap: ${({ theme }) => theme.spacing.zero_3};

  & svg path {
    stroke: ${({ theme, cardActionsIconColor }) =>
      cardActionsIconColor ? cardActionsIconColor : theme.colors.black_60};
  }
    cursor: pointer;
  }
`;

export const CardItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.zero_2} ${({ theme }) => theme.spacing.zero_3};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0;
  }
`;

export const CardLabelContainer = styled.div`
  display: flex;
  align-items: start;
`;

export const CardIcon = styled.div`
  display: inline-block;
  padding-right: ${({ theme }) => theme.spacing.zero_3};

  // & svg path {
  //   stroke: ${({ theme }) => theme.colors.black_60};
  // }
`;

export const CardLabel = styled.h6<{ $isBold?: boolean }>`
  color: ${({ theme }) => theme.colors.black_60};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};

  ${({ $isBold }) =>
    $isBold &&
    css`
      font-weight: ${({ theme }) => theme.fontWeight.bold};
      color: ${({ theme }) => theme.colors.black_100};
    `}
`;

export const CardValue = styled.p`
  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  text-align: right;
  display: flex;
`;

export const CardDivider = styled.hr<{ margin?: string }>`
  margin: ${({ margin, theme }) =>
    margin ? margin : `${theme.spacing.one} -${theme.spacing.one}`};
  border-top: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black_20};
  width: 100%;
`;

// TODO name this better
export const CardDivider2 = styled.hr<{ margin?: string }>`
  margin: ${({ margin, theme }) => (margin ? margin : `0 0 ${theme.spacing.one} 0`)};

  border-top: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black_20};
`;
